import { render } from "./DataValue.vue?vue&type=template&id=662273da"
import script from "./DataValue.vue?vue&type=script&lang=js"
export * from "./DataValue.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__